import { get } from '@aiptyg/api-client';
import type { CommissionListResponseDTO } from '../types/commissions.types';

export interface CommissionListParams {
  page: number;
  pageSize: number;
  beneficiaryUserId: string;
  sourceUserId: string;
  level: string;
  type: string;
  range: string;
}

export function listCommissions(params: CommissionListParams): Promise<CommissionListResponseDTO> {
  const qs = new URLSearchParams();
  qs.set('page', String(params.page));
  qs.set('page_size', String(params.pageSize));
  if (params.beneficiaryUserId) qs.set('beneficiary_user_id', params.beneficiaryUserId);
  if (params.sourceUserId) qs.set('source_user_id', params.sourceUserId);
  if (params.level) qs.set('level', params.level);
  if (params.type) qs.set('type', params.type);
  if (params.range) qs.set('range', params.range);
  return get<CommissionListResponseDTO>(`/v1/admin/commissions?${qs.toString()}`);
}
